import React from "react";
import { store, persistor } from "store/index";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import PhoneInputField from "components/Inputs/PhoneInputField";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      indexModal: false,
      name: "",
      phone: "",
      email: "",
      center: "",
      process: false,
      taskModal: false,
      task_success_bag: "",
      task_error_bag: "",
      task_name: "",
      task_phone: "",
      task_email: "",
      task_institute: "",
      branches: [],
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    if (!store.getState().token) {
      setTimeout(() => {
        this.setState({ indexModal: true });
      }, 1000);
    }
  }

  closeIndexModal = (event) => {
    event.preventDefault();
    this.setState({ indexModal: false });
  };

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handlePhoneChange = (event) => {
    this.setState({ phone: event });
  };

  postSubmit = async (e) => {
    e.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    this.setState({ process: true });
    const bodyFormData = new FormData();
    bodyFormData.append("phone", this.state.phone);
    bodyFormData.append("name", this.state.name);
    bodyFormData.append("email", this.state.email);
    bodyFormData.append("center", this.state.center);

    let res = null;
    // try {
    //   res = await API({
    //     method: "POST",
    //     url: "/submit-query",
    //     data: bodyFormData,
    //   });
    // } catch (error) {
    //   this.setState({ process: false });
    //   return;
    // }

    if (res?.status === 200) {
      this.props.history.push({
        pathname: "/trial-class-thankyou",
        state: { flag: true },
      });
      this.setState({ indexModal: false });
    } else if (res?.response?.status === 422) {
      this.setState({ error: res.response, process: false });
      let str = "";
      Object.values(this.state.error.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });
      this.setState({ error_bag: str });
    }
  };

  render() {
    return (
      <React.Fragment>
        <footer id="pte-footer">
          <div className="container">
            {store.getState().is_main && (
              <div>
                <div className="footer-logo">
                  <Link to="/">
                    <img src="/images/web-new-images/footer-logo.png" alt="LA" />
                  </Link>
                </div>
                <div className="row footer-row">
                  <div className="col footerWidget">
                    <h3>PTE</h3>
                    <ul>
                      <li>
                        <Link to="/pte-coaching-classes-parramatta">
                          About PTE
                        </Link>
                      </li>
                      <li>
                        <Link to="/pte-core">About PTE Core</Link>
                      </li>
                      <li>
                        <Link to="/pte-online-classes">Online classes</Link>
                      </li>
                      {/* <li>
                                  <Link to="/mock-test">Mock Test</Link>
                              </li> */}
                      <li>
                        <Link to="/pte-study-material">Study Material</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col footerWidget">
                    <h3>NAATI</h3>
                    <ul>
                      <li>
                        <Link to="/naati-coaching-classes-parramatta">
                          NAATI Hindi Coaching
                        </Link>
                      </li>
                      <li>
                        <Link to="/naati-coaching-classes-parramatta">
                          NAATI Punjabi Coaching
                        </Link>
                      </li>
                      <li>
                        <Link to="/naati-coaching-classes-parramatta">
                          NAATI Urdu Coaching
                        </Link>
                      </li>
                      <li>
                        <Link to="/naati-coaching-classes-parramatta">
                          NAATI Nepali Coaching
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col footerWidget">
                    <h3>ABOUT US</h3>
                    <ul>
                      <li>
                        <Link to="/about">Our Story</Link>
                      </li>
                      <li>
                        <Link to="/sitemap">Sitemap</Link>
                      </li>
                      <li>
                        <Link to="/join-us">Career</Link>
                      </li>
                      <li>
                        <Link to="/franchise">Franchise</Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col footerWidget">
                    <h3>PRACTICE MATERIAL</h3>
                    <ul>
                      <li>
                        <Link to="/pte-reading-test-practice-material">
                          Reading
                        </Link>
                      </li>
                      <li>
                        <Link to="/pte-writing-test-practice-material">
                          Writing
                        </Link>
                      </li>
                      <li>
                        <Link to="/pte-listening-test-practice-material">
                          Listening
                        </Link>
                      </li>
                      <li>
                        <Link to="/pte-speaking-test-practice-material">
                          Speaking
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row footer-contact-info">
                  <div className="col-md-7 col-lg-9">
                    <div className="contact-info">
                      <h3>Contact Us</h3>
                      <ul>
                        <li>
                          <a href="mailto:info@languageacademy.com.au">
                            <span>info@languageacademy.com.au</span>
                          </a>
                        </li>
                        <li>
                          <a href="tel:61426230061">
                            <span>+61 426230061</span>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://goo.gl/maps/bhiU4au3764eDjVu8"
                            target="_blank"
                          >
                            <span>46 George Street, Parramatta</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-5 col-lg-3 footer-social-wrapper">
                    <h3>Follow Us</h3>
                    {store.getState().is_main && (
                      <div className="footer-social-icons">
                        <a
                          target="_blank"
                          href="https://www.facebook.com/languageacademyaustralia/"
                        >
                          <img src="/images/web-new-images/icons/facebook-icon.svg" alt="LA" />
                        </a>
                        <a
                          target="_blank"
                          href="https://www.linkedin.com/authwall?trk=gf&trkInfo=AQGxYvTu-VIE8gAAAXQBcysYhyoeMLsNbqRf-PuswFI8RzAL5y60LYHKbYMYZBVifPWMn7AFIF4-pI_yN6twk7IVrKwK8kV3mABFKcSSuEZ6xhISNB9XifF45GiA8j3LNNc6bZo=&originalReferer=https://www.languageacademy.com.au/sitemap.html&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Flanguage-academy-australia"
                        >
                          <img src="/images/web-new-images/icons/linkedin-icon.svg" alt="LA" />
                        </a>
                        <a
                          target="_blank"
                          href="https://www.instagram.com/languageacademyau/"
                        >
                          <img src="/images/web-new-images/icons/insta-icon.svg" alt="LA" />
                        </a>
                        <a
                          target="_blank"
                          href="https://twitter.com/lang_acad_au"
                        >
                          <img src="/images/web-new-images/icons/x-icon.svg" alt="LA" />
                        </a>
                        {/* <a
                                  target="_blank"
                                  href="https://www.pinterest.com.au/LanguageAcademyAustralia/"
                                  >
                                  <img src={SocialIcon2} alt="LA" />
                                  </a> */}
                        <a
                          target="_blank"
                          href="https://www.youtube.com/channel/UC-yXI8Y7cry-D5uuNGbYbsw"
                        >
                          <img src="/images/web-new-images/icons/youtube-icon.svg" alt="LA" />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="row bottomFooter">
              <div className="col-md-6 pl-0">
                <p className="copyright">
                  Copyright © {new Date().getFullYear()} LanguageAcademy. All
                  rights reserved
                </p>
              </div>
              <div className="col-md-6 pr-0">
                <ul>
                  <li>
                    <Link to="/term">Terms of Use</Link>
                  </li>
                  <li className="separator"></li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li className="separator"></li>
                  <li>
                    <Link to="/refund-policies">Refund Policies</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

        {/* Modal */}
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
          <div className="modal-dialog main-popup">
            <div className="modal-content">
              <div className="modal-header">
                {/* <button onClick={this.closeIndexModal} style={{ color: "#93c13e", opacity: "unset" }} href="#" className="close">
                  <span aria-hidden="true">
                    <img className="img-fluid" src="/images/web-new-images/icons/close-icon2.svg" alt="LA" />
                  </span>
                </button> */}
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/icons/close-icon2.svg"
                      alt="LA"
                    />
                  </span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="form-content-outer m-0">
                  <div className="form-content">
                    <div className="main-popup-img form-img">
                      <img className="img-fluid" src="/images/web-new-images/hero_img-02.png" alt="LA" />
                    </div>
                    <div className="main-popup-content form-content-right">
                      <h4 className="popup-title">Attend a FREE TRIAL CLASS for PTE, NAATI CCL or IELTS with us.</h4>
                      <p className="popup-sub-title">Submit Your Details Below</p>
                      <div className="pte-popup-form-start">
                        <form onSubmit={this.postSubmit}>
                          <div className="col-md-12">
                            <div className="fieldOuter">
                              <label htmlFor="Name">Name*</label>
                              <div className="form-input-outer">
                                <input id="Name" className="form-input" name="name" placeholder="Enter Name" type="text" value={this.state.name} onChange={this.changeInput} />
                              </div>
                              {this.validator.message("name", this.state.name, "required")}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="fieldOuter">
                              <label htmlFor="PhoneNumber">Phone Number</label>
                              <PhoneInputField value={this.state.phone} changeEvent={this.handlePhoneChange} addClass="popup-class" />
                              {this.validator.message("phone", this.state.phone, "required|phone")}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="fieldOuter">
                              <label htmlFor="email">Email*</label>
                              <div className="form-input-outer">
                                <input id="email" className="form-input" name="email" placeholder="Enter Email" type="email" value={this.state.email} onChange={this.changeInput} />
                              </div>
                              {this.validator.message("email", this.state.email, "required|email")}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="fieldOuter">
                              <label htmlFor="Center">Center</label>
                              <div className="form-input-outer form-select-wrapper">
                                <select id="Center" className="form-input" name="center" value={this.state.center} onChange={this.changeInput}>
                                  <option value="">Select center</option>
                                  <option>Parramatta</option>
                                  <option>Sydney CBD</option>
                                  <option>Jalandhar</option>
                                  <option>Gurdaspur</option>
                                  <option>Amristar</option>
                                  <option>Sirsa</option>
                                  <option>Sri Ganganagar</option>
                                  <option>Kurukshetra</option>
                                  <option>Online</option>
                                </select>
                              </div>
                              {this.validator.message("center", this.state.center, "required")}
                            </div>
                          </div>

                          <div className="col-md-12 row_before_pte_submit">
                            {!this.state.process ? (
                              <button type="submit" className="primary-btn">
                                SUBMIT <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                              </button>
                            ) : (
                              <button className="btn btn-primary pte_popup_modal_submit" disabled>
                                Wait...
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Footer;
